import { useLocation, useNavigate } from "react-router";
import { BASE_URL, HttpMethod } from "../../../services/api.constant";
import { detailHistoryOrder } from "../../../services/apiList";
import { callHttpClientMethod } from "../../../services/callHttpClient";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux";
import { Box, Typography } from "@mui/material";
import { OrderHistoryDetailPageSkeleton } from "../../../components/skeletons/AppPageSkeletons";
import Container from "../../../components/Header/common/Container";
import { DataHistory } from "../../../gobalType";
import moment from "moment";
import { TypesAction } from "../../../redux/typesAction";
import "../style.scss";
import DefaultText from "../../../components/Text/DefaultText";
import { toast } from "react-toastify";
import { OrderStatusTimeline } from "./components/OrderStatusTimeline";
import { OrderItemsTable } from "./components/OrderItemsTable";

function OrderHistoryDetail() {
  const [status, setStatus] = useState(0);
  const { auth } = useSelector((state: RootState) => state.auth);
  const { carts } = useSelector((state: RootState) => state.cart);
  const [orderDetail, setOrderDetail] = useState<DataHistory>();

  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const canAddToCart = (newItem: any) => {
    if (carts.length === 0) return true;
    const currentCategory = carts[0].isCategory;
    return currentCategory === newItem.isCategory;
  };

  const orderHistoryDetail = useCallback(async () => {
    setLoading(true);
    const response = await callHttpClientMethod(
      BASE_URL + detailHistoryOrder(location?.state),
      HttpMethod.Get,
      {},
      {
        headers: {
          Authorization: `Bearer ${auth.access_token}`,
        },
      }
    );
    setOrderDetail(response.data);
    setLoading(false);
  }, [auth.access_token, location?.state]);

  const activeStatusOrder = useCallback(() => {
    switch (orderDetail?.status) {
      case "ORDER_PLACED":
        setStatus(1);
        break;
      case "ORDER_APPROVED":
        setStatus(2);
        break;
      case "ORDER_SHIPPING":
      case "ORDER_ARRIVED":
      case "ORDER_PAID":
        setStatus(3);
        break;
      default:
        setStatus(1);
        break;
    }
  }, [orderDetail?.status]);

  useEffect(() => {
    activeStatusOrder();
  }, [activeStatusOrder]);

  useEffect(() => {
    orderHistoryDetail();
  }, [orderHistoryDetail]);
  if (loading) {
    return <OrderHistoryDetailPageSkeleton />;
  }
  const handleBuyAgain = (item: any) => {
    console.log(item, 'item');
    
    const product = {
      ...item.product,
      sizeName: item.size.name,
      size_id: item.size.id,
      quantity: Number(orderDetail?.total_qty || 0),
      price: Number(item.price) || 0,
      extractID: item.size.id + "" + orderDetail?.id,
      isCategory: item.category_id == 1 ? "pcs" : "plt",
      thumbnail: item?.product?.images,
      product_name: item?.product?.name,
    };
    if (!canAddToCart(product)) {
      toast.error("You can only add one product type to cart");
      return;
    }

    dispatch({
      type: TypesAction.ADD_TO_CART,
      payload: product,
    });
    navigate("/cart");
  };
  return (
    <Container
      className="bg_order"
      maxWidth="md"
      component="main"
      sx={{
        backgroundColor: "#fff",
        paddingTop: "20px",
        padding: "10px",
      }}>
      <Typography
        sx={{
          fontWeight: 600,
          marginBottom: 2,
          fontSize: { xs: "16px", sm: "24px" },
          textAlign: "center",
          marginTop: { xs: "-40px", sm: "0px" },
        }}>
        ORDER DETAIL
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 2,
        }}>
        <DefaultText>
          Order No:{" "}
          <span style={{ fontWeight: 600 }}>{orderDetail?.order_code}</span>
        </DefaultText>
        <DefaultText>
          {moment(orderDetail?.created_at).format("MM/DD/YYYY")}
        </DefaultText>
      </Box>
      <OrderStatusTimeline status={status} />
      <OrderItemsTable orderDetail={orderDetail} onBuyAgain={handleBuyAgain} />
    </Container>
  );
}

export default OrderHistoryDetail;
